import * as React from "react";

function SvgSlant2Shadow(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1600 200" filter="url(#slant-2-shadow_svg__a)" enableBackground="new 0 0 1600 200" {...props}><filter id="slant-2-shadow_svg__a"><feGaussianBlur in="SourceAlpha" stdDeviation={4} /><feComponentTransfer><feFuncA type="linear" slope={0.4} /></feComponentTransfer><feMerge><feMergeNode /><feMergeNode in="SourceGraphic" /></feMerge></filter><path className="slant-2-shadow_svg__st1" d="M1610 39.2v12L800 170.1-10 51.2v-12l810 118.9 810-118.9z" /></svg>;
}

export default SvgSlant2Shadow;